import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import useSWR from 'swr'
import { ContactId } from '../../types/contact-interface'
import { ContactWorkflowApiInterface } from '../types/contact-workflow-interface'

interface UseContactWorkflowsInterface extends SwrPaginationInterface {
  contactId: ContactId
}

export function useContactWorkflows({
  limit,
  pagination,
  contactId,
}: UseContactWorkflowsInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactWorkflowApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: contactWorkflows } = useSWR(() => {
    if (user) {
      return `${CONTACT_API}/${contactId}/workflows/list?${getPaginationQueryString({
        limit,
        pagination,
      })}`
    }
    return null
  }, fetcher)

  return { contactWorkflows }
}
